import moment from 'moment';
import React, { useMemo } from 'react';
import ListItem, { ListItemContent } from '../../../elements/ListItem';
import Location from '../../../elements/Location';
import TimeSpan from '../../../elements/TimeSpan';
import SpeakerLinkedSponsorIcon from '../../EventSchedule/common/SpeakersList/SpeakerLinkedSponsorIcon/SpeakerLinkedSponsorIcon';
import styles from './SpeakerRole.module.scss';
import Link from '../../../elements/Link';
import RightChevron from '../../../elements/RightChevron';
import { itemHasContent } from '../../../../data/filters/directory/itemHasContent';

export default function SpeakerRole(props) {
    const { sr, event, className = '', style } = props,
        filteredRoles = useMemo(() => {
            return sr.roles.filter((role) => role.title || role.role || role.linked_sponsor_id);
        }, [sr]);

    return (
        <li className="item whitebg" style={style}>
            <h4>{moment(sr.programItem.start).format('dddd D MMMM')}</h4>
            <ListItem tagName="div" className={[className, styles.SpeakerRole].join(' ')}>
                <TimeSpan start={sr.programItem.start} end={sr.programItem.end} />
                <ListItemContent>
                    <Link className={styles.content} href={['.', 'program', sr.programItem.id].join('/')}>
                        <div>
                            <div className="text main">{sr.programItem.name}</div>
                            <Location className={styles.location}>{sr.programItem.location}</Location>
                        </div>
                        {itemHasContent(sr.programItem) ? <RightChevron /> : null}
                    </Link>
                    {filteredRoles.length ? (
                        <ul className={styles.roleslist}>
                            {filteredRoles.map((role, i) => {
                                let content = (
                                    <>
                                        <div className={styles.title}>{role.title}</div>
                                        <div className={styles.role}>{role.role}</div>
                                        {role.linked_sponsor_id ? <SpeakerLinkedSponsorIcon className={styles.icon} relation={role.linked_sponsor_relation} /> : null}
                                    </>
                                );
                                if (role.linked_sponsor_id) {
                                    content = <Link href={['.', 'directory', role.linked_sponsor_id].join('/')}>{content}</Link>;
                                }

                                return <li key={i}>{content}</li>;
                            })}
                        </ul>
                    ) : null}
                </ListItemContent>
            </ListItem>
        </li>
    );
}
